// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"343":"itowns_potree2worker","899":"itowns_lasparser"}[chunkId] + ".js";
};